<ngx-loading-bar [includeSpinner]="false" [color]="'#ff8c00'" [height]="'3px'"></ngx-loading-bar>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<div class="container d-flex flex-column">
    <app-header></app-header>
    <app-navbar></app-navbar>
    <router-outlet class="mt-2 wrapper"></router-outlet>
    <app-footer></app-footer>
</div>
